import { ControlledInput } from "@/components/controlled-input"
import { filterInvalidUsernameCharacters } from "@/lib/validations/filter-invalid-username-characters"

export const USERNAME_REQUIRED_ERROR = "Errors.usernameRequiredError"

export function LoginFormUsernameInput() {
  return (
    <ControlledInput
      label="LoginPage.LoginForm.usernameFieldLabel"
      name="usernameEtc"
      autoComplete="on"
      maxLength={50}
      filterValue={filterInvalidUsernameCharacters}
    />
  )
}
